
<!-- src/App.vue -->

<template>
  <div id="app">
    <GlobalNavBar></GlobalNavBar>
    <router-view></router-view>
  </div>
</template>
<style src="@/styles/styles.css"></style>
<style src="@/styles/dissentiaStyles.css"></style>
<script>
import GlobalNavBar from '@/GlobalNavBar.vue';
export default {
  name: 'App',
  components: {
    GlobalNavBar,
  },
};
</script>
